export default __webpack_public_path__ + "static/media/list-view.031fbbc3.svg";